<template>
  <div :class="`m-mobile m-mobile-${routeType}-list mobile-${vlistClass}`" >
      <iframe
      src="https://720yun.com/t/d4vknq1m0dq?scene_id=31515277"
      v-if="$route.params._module==='zhuzizhangguan'"
      class="iheight"
    ></iframe>
    <iframe
      src="http://zzwh-hotel.whlyw.net/Hotel/MobileIndex"
      v-if="$route.params._module==='hotel'"
      style="width:100%;height:1000px;border:0"
    ></iframe>
    <iframe
      src="http://m.whlyw.net/SpotTicket/SpotTicket?webtype=zhuzi"
      v-else-if="$route.params._module==='ticket'"
      style="width:100%;height:1000px;border:0"
    ></iframe>
  </div>
</template>
<script>
export default {
  data() {
    return {
      routeType: "arti",
      titlearr: {
        zhuzizhangguan:'朱子展馆',
        hotel: "酒店",
        ticket: "门票",
      }
    };
  },
  components: {},
  computed: {
    vlistClass() {
      if (this.$route.params._field==="zhuzizhangguan") {
        return "zhuzizhangguan";
      }
      else if(this.$route.params._field==="720_detail"){
           return "720";
      }
    }
  },
  methods: {},
  created() {
    this.$menuFn.setTitle(this.titlearr[this.$route.params._module]);
  },
  watch: {
    $route: function(to, from) {
      if (to.name === "mobile-arti-list") {
        this.$menuFn.setTitle(this.titlearr[this.$route.params._module]);
      }
      let contains = this.$loadRouteData(
        from,
        to,
        this.routeType,
        "list",
        "mobile",
        true
      );
      if (this.routeWatch && contains) {
        this.$refs["refId"].clearData();
        this.meta.module = this.$route.params._module;
        this.meta.field = this.$route.params._field;
        this.$refs["refId"].loadData();
      }
    }
  }
};
</script>
<style lange="sass" scoped>
.mobile-zhuzizhangguan{
  padding-bottom: 0 !important;
}
.m-mobile-arti-list{
  padding-bottom: 100px;
}
@media screen and (max-height: 820px) {
  .iheight {
    border: 0;
    height: 752px;
    width: 100%;
    cursor: pointer;
  }
}
@media screen and (max-height: 737px) {
  .iheight {
    border: 0;
    height: 676px;
    width: 100%;
    cursor: pointer;
  }
}
@media screen and (max-height: 668px) {
  .iheight {
    border: 0;
    height: 608px;
    width: 100%;
    cursor: pointer;
  }
}
@media screen and (max-height: 600px) {
  .iheight {
    border: 0;
    height: 508px;
    width: 100%;
    cursor: pointer;
  }
}
</style>